import { render, staticRenderFns } from "./BiCohorts.vue?vue&type=template&id=7cba7383&"
import script from "./BiCohorts.vue?vue&type=script&lang=js&"
export * from "./BiCohorts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports